import { FBClientIntakeFormsState } from './clientIntakeForms.firebase.state';

export class FBClientIntakeFormsSelectors {
	static readonly _props = FBClientIntakeFormsState._props;

	static readonly $businessId = FBClientIntakeFormsSelectors._props.businessId;
	static readonly $matterId = FBClientIntakeFormsSelectors._props.matterId;
	static readonly $clientIntakeFormId =
		FBClientIntakeFormsSelectors._props.clientIntakeFormId;

	static readonly $getCurrentClientIntakeForm =
		FBClientIntakeFormsSelectors._props.item;
}
